import Severity from '../constants/Severity';
import BaseModel from './BaseModel';

export interface CommentId {__commentId: number}

export default class Comment extends BaseModel<CommentId> {
  content = '';
  severity: Severity | null = null;

  clone(): Comment {
    return Object.assign(new Comment(), this);
  }
}
